import { siteTimezoneSelectOptions } from "../lib/timezone-options";

export function TimezoneSelect({
  value,
  onChange,
  id,
  required = false,
}: {
  value: string;
  onChange: (next: string) => void;
  id?: string;
  required?: boolean;
}) {
  const options = siteTimezoneSelectOptions(value);
  return (
    <select id={id} value={value} onChange={(event) => onChange(event.target.value)} required={required}>
      {options.map((option) => (
        <option key={option.value} value={option.value}>
          {option.label}
        </option>
      ))}
    </select>
  );
}
